import { render, staticRenderFns } from "./TablaAnalisisComercial.vue?vue&type=template&id=0765f94e&scoped=true"
import script from "./TablaAnalisisComercial.vue?vue&type=script&lang=js"
export * from "./TablaAnalisisComercial.vue?vue&type=script&lang=js"
import style0 from "./TablaAnalisisComercial.vue?vue&type=style&index=0&id=0765f94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765f94e",
  null
  
)

export default component.exports